import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, Paper } from '@mui/material';
import WebService from '@util/webService'
import {copyProperties, encodeParams, getAction, isStringNullOrEmpty, printVariable, searchCompany} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import Box from '@mui/material/Box';
import useAlert from "@hooks/useAlert";
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useMediaQuery } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from "@components/ConfirmDialog";
import useDelegate from "@hooks/useDelegate";
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileUserPage = () => {
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value: -1, visible: false, canSrch: false, selList:[]},
    {field: 'name', placeholder: '이름',    type:'text', value:'', visible: true, canSrch: true, selList:[]},
    {field: 'statCode', placeholder: '',    type:'text', value: 'S001', visible: false, canSrch: false,selList:[]},
    {field: 'phone', placeholder: '전화', type:'number', value: '', visible: true, canSrch: true, selList:[]},
    {field: 'loginId', placeholder: '로그인ID', type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'password', placeholder: '비밀번호', type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'password2', placeholder: '비밀번호확인', type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'phoneCertYn', placeholder: '폰인증여부', type:'text', value: 'N', visible: true, canSrch: false, selList:[]},
    {field: 'deviceToken', placeholder: '디바이스토큰', type:'text', value: '', visible: false, canSrch: false, selList:[]},
    {field: 'email', placeholder: '이메일', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'emailCode', placeholder: '이메일 인증코드', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'address', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'address2', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'zipCode', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'phone', placeholder: '휴대폰', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'regTime', placeholder: '등록일시', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'uptTime', placeholder: '수정일시', type:'text', value:'', visible: false, canSrch: false, selList:[]},
  ]

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  
  const [dataList, set_dataList] = useState([])
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const dgHandler = useState(false)
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)

  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)

  const [record, set_record] = useState({})

  const navigate = useNavigate()

  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }


  useEffect(() => {
    onLoad()
  }, [])

  
  const onLoad = async() => {
    openIndicator()

    const url = `/user/id/${account.user.id}`
    const resp = await WebService.get(url, {})
    if(resp.repCode === 'reject') {
      navigate('/login')
    }

    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      
      const newRecord = JSON.parse(repMessage.record)
      newRecord.oldPassword = ''
      newRecord.newPassword = ''
      newRecord.newPassword2 = ''

      set_record(newRecord)
      // activeRow.loginId = newRecord.loginId
      // copyProperties(newRecord, valuesRef.current)
      updateState(newRecord)
    }
    closeIndicator()
  }

  ////
  const onSubmit = async () => {
    const url = `/user/password/new/${account.user.id}`
    const data = {
      password: activeRow.oldPassword,
      newPassword: activeRow.newPassword,
    }

    const resp = await WebService.post(url, data)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
    }
    else {
      alert('수정되었습니다.')
    }
  }

  const validate = (name, value) => {
    let err = ''
    if(name === 'oldPassword') {
      if (isStringNullOrEmpty(value)) {
        err = '기존 비밀번호를 입력해 주세요.'
      } 
    }

    if(name === 'newPassword') {
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/
      if (!passwordRegex.test(value)) {
        err = '숫자+영문자+특수문자 조합으로 8자리 이상 입력해주세요.'
      } 
    }

    if(name === 'newPassword2') {
      if(value === '') {
        err = '패스워드가 일치하는지 확인해 주세요.'
      }
      if( factor['newPassword'] !== value) {
        err = '패스워드가 일치하는지 확인해 주세요(2).'
      }
    }

    // if(name === 'phone') {
    //   const phoneRegex = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/
    //   if(!phoneRegex.test(value)) {
    //     err = '올바른 휴대폰번호 형식이 아닙니다.'
    //   }
    // }

    return err
  }

  const {activeRow, errors, updateState, handleChange, handleSubmit, factor} = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  });


  const MainContent = () => {
    return(
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          label={'아이디(이메일)'}
          name={'loginId'}
          value={activeRow['loginId']}
          onChange={handleChange}
          error={errors['loginId']}
          InputProps={{readOnly: true, }}
          InputLabelProps={{shrink: activeRow.loginId}}
        />
      </Grid>
      <FormHelperTexts>{errors['loginId']}</FormHelperTexts>
      <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          label={'이름'}
          name={'name'}
          value={activeRow['name']}
          onChange={handleChange}
          error={errors['name']}
          InputProps={{
            readOnly: true,
          }}
          InputLabelProps={{shrink: activeRow.name}}
        />
      </Grid>
      <FormHelperTexts>{errors['name']}</FormHelperTexts>
      <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          label={'휴대폰번호'}
          name={'phone'}
          value={activeRow['phone']}
          error={errors['phone']}
          InputProps={{readOnly: true, }}
          InputLabelProps={{shrink: activeRow.phone}}
        />
      </Grid>
      <FormHelperTexts>{errors['phone']}</FormHelperTexts>
      <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          type="password"
          label={'기존 비밀번호'}
          name={'oldPassword'}
          defaultValue={activeRow['oldPassword']}
          onChange={handleChange}
          error={errors['oldPassword']}
        />
      </Grid>
      <FormHelperTexts>{errors['oldPassword']}</FormHelperTexts>
      <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          type="password"
          label={'새 비밀번호'}
          name={'newPassword'}
          defaultValue={activeRow['newPassword']}
          onChange={handleChange}
          error={errors['newPassword']}
        />
      </Grid>
      <FormHelperTexts>{errors['newPassword']}</FormHelperTexts>
       <Grid item xs={12}>
        <TextField
          size='small'
          required
          fullWidth
          type="password"
          label={'새 비밀번호 확인'}
          name={'newPassword2'}
          defaultValue={activeRow['newPassword2']}
          onChange={handleChange}
          error={errors['newPassword2']}
        />
      </Grid>
      <FormHelperTexts>{errors['newPassword2']}</FormHelperTexts>
      
    </Grid>
    )
  }
  return (
    <Container component="main" maxWidth="sm">
       <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>기본 정보</h1>
          </div>
        </div>
     
      <CssBaseline />
      <FormControl component="fieldset" variant="standard" >
        {isMobile? (
           MainContent()
          ): (
            MainContent()
          )
        }
        
        <Grid container>
          <Grid item xs={12}>

            <ConfirmDialog
              btn={<FlatButton fullWidth variant='contained' color='primary' sx={{mt:2, height:'2.3em'}}>수정</FlatButton>}
              title={'알림'}
              content={'정보를 수정하시겠습니까?'}
              bc={'primary'}
              preHandle={ async () => {
                return Object.values(errors).filter(v => v).length === 0
              }}
              perform={() => {
                handleSubmit()
              }}
            />
            {/*<Button variant='contained' fullWidth color='primary' size='small' onClick={handleSubmit} sx={{mt: 2, fontSize:'1em'}}>수정</Button>*/}
          </Grid>
        </Grid>
      </FormControl>
      <div>
        {renderIndicator()}
        {renderAlert()}
      </div>
  </Container>
  );
}

export default ProfileUserPage
